var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-4 font-weight-thin",domProps:{"innerHTML":_vm._s(_vm.sitecontent.tosTextArea)}})
}
var staticRenderFns = []

export { render, staticRenderFns }